export class DashboardAmountOfMoneyEarnedModel {
    value:number = 0
    date:Date|string|null = null

    constructor(d?:Partial<DashboardAmountOfMoneyEarnedModel>) {
        Object.assign(this, d)
    }
}
